import { Flex } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { Title } from '@component/title.component';
import { TopBar } from '@component/top_bar.component';

interface ScreenErrorProps {
	title: string;
}

export function ScreenError({ title }: ScreenErrorProps) {
	return (
		<Flex gap={tokens.spacing.x1_5}>
			<TopBar.Content goBack />
			<Title title={title} titleSize='small' />
		</Flex>
	);
}
